import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import GeulpicConsentModal from "../../components/modal/geulpic_consent_modal";
import GeulpicThirdPartyModal from "../../components/modal/geulpic_third_party_modal";
import ProductAuthModal from "../../components/modal/product_auth_modal";
import GeulpicSubscriptionForm from "./geulpic_subscription_form";
import GeulpicPurchaseComplete from "./geulpic_purchase_complete";
import { checkSubscription } from "../../utils/common";

const GeulpicSubscriptionPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const fromPocketPeace = location.state?.fromPocketPeace;
  const phoneNum = location.state?.phoneNumber;

  const [currentStep, setCurrentStep] = useState(
    fromPocketPeace ? "form" : "consent"
  );
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");

  const [searchParams] = useSearchParams();

  const userRef = searchParams.get("user_ref") || "";
  const amount = parseInt(searchParams.get("amount") || "10000");

  useEffect(() => {
    checkSubscription();
  }, []);

  useEffect(() => {
    setPhoneNumber(phoneNum);
  }, [phoneNum]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentStep]);

  useEffect(() => {
    if (currentStep === "phoneVerification") {
      setIsAuthModalOpen(true);
    }
  }, [currentStep]);

  const handleConsentNext = () => {
    setCurrentStep("thirdParty");
  };

  const handleThirdPartyNext = () => {
    setCurrentStep("phoneVerification");
  };

  const handleAuthSuccess = (phoneNumber) => {
    setPhoneNumber(phoneNumber);
    setIsAuthModalOpen(false);
    setCurrentStep("form");
  };

  const handleAuthClose = () => {
    setIsAuthModalOpen(false);

    if (currentStep === "phoneVerification") {
      setCurrentStep("thirdParty");
    }
  };

  const handlePaymentSuccess = (paymentResult, formData) => {
    console.log("결제 성공:", paymentResult);
    setCurrentStep("complete");
  };

  const handlePaymentError = (error) => {
    console.error("결제 실패:", error);
    // 필요시 에러 처리 로직 추가
  };

  const handleComplete = () => {
    navigate("/");
  };

  const handleClose = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  return (
    <div className="subscription-page-wrapper">
      {!fromPocketPeace && (
        <>
          <GeulpicConsentModal
            isOpen={currentStep === "consent"}
            onClose={handleClose}
            onNext={handleConsentNext}
          />

          <GeulpicThirdPartyModal
            isOpen={currentStep === "thirdParty"}
            onClose={handleClose}
            onNext={handleThirdPartyNext}
          />

          <ProductAuthModal
            isOpen={isAuthModalOpen}
            onClose={handleAuthClose}
            onSuccess={handleAuthSuccess}
          />
        </>
      )}

      {currentStep === "form" && (
        <GeulpicSubscriptionForm
          phoneNumber={phoneNumber}
          userRef={userRef}
          amount={amount}
          onPaymentSuccess={handlePaymentSuccess}
          onPaymentError={handlePaymentError}
        />
      )}

      {currentStep === "complete" && (
        <GeulpicPurchaseComplete onConfirm={handleComplete} />
      )}
    </div>
  );
};

export default GeulpicSubscriptionPage;
